import { useState, useEffect } from "react";
import { X, Shield, Briefcase, HardHat, Wrench, Calculator, Users, ShoppingCart, Zap, Crown } from "lucide-react";

const WELCOME_MESSAGES = {
  "Superadministrador": {
    icon: Crown,
    accentColor: "from-amber-500 to-amber-600",
    accentBg: "bg-amber-500",
    accentText: "text-amber-400",
    badgeBg: "bg-amber-100 text-amber-700",
    ringColor: "ring-amber-300",
    getMessage: (name) => ({
      title: `Bienvenido, ${name}`,
      subtitle: "Control Total del Sistema",
      body: `Tu plataforma de control total esta lista. Monitorea cada operacion, cada movimiento financiero y cada decision de tu equipo en tiempo real. Todo CEN Ingenieria bajo tu supervision.`,
    }),
  },
  "Administrador": {
    icon: Shield,
    accentColor: "from-[#2E6DA4] to-[#1A4A7A]",
    accentBg: "bg-[#2E6DA4]",
    accentText: "text-blue-300",
    badgeBg: "bg-blue-100 text-blue-700",
    ringColor: "ring-blue-300",
    getMessage: (name) => ({
      title: `Bienvenido, ${name}`,
      subtitle: "Administracion General",
      body: `Todo listo para gestionar. Tenes acceso completo para supervisar operaciones, aprobar procesos y mantener CEN funcionando al maximo rendimiento.`,
    }),
  },
  "Gerente Tecnico": {
    icon: Briefcase,
    accentColor: "from-indigo-500 to-indigo-600",
    accentBg: "bg-indigo-500",
    accentText: "text-indigo-300",
    badgeBg: "bg-indigo-100 text-indigo-700",
    ringColor: "ring-indigo-300",
    getMessage: (name) => ({
      title: `Bienvenido, ${name}`,
      subtitle: "Gestion Tecnica",
      body: `Tu panel tecnico te espera. Revisa el avance de proyectos, coordina con tu equipo y toma decisiones informadas para cada obra.`,
    }),
  },
  "Coordinador de Obra": {
    icon: HardHat,
    accentColor: "from-teal-500 to-teal-600",
    accentBg: "bg-teal-500",
    accentText: "text-teal-300",
    badgeBg: "bg-teal-100 text-teal-700",
    ringColor: "ring-teal-300",
    getMessage: (name) => ({
      title: `Bienvenido, ${name}`,
      subtitle: "Coordinacion de Obra",
      body: `Tu obra te necesita. Controla el avance diario, gestiona tu equipo y mantene todo bajo control en campo.`,
    }),
  },
  "Ingeniero Residente": {
    icon: Zap,
    accentColor: "from-cyan-500 to-cyan-600",
    accentBg: "bg-cyan-500",
    accentText: "text-cyan-300",
    badgeBg: "bg-cyan-100 text-cyan-700",
    ringColor: "ring-cyan-300",
    getMessage: (name) => ({
      title: `Bienvenido, ${name}`,
      subtitle: "Ingenieria Residente",
      body: `Todo listo en tu proyecto. Revisa inventario, registra avances y mantene la comunicacion fluida con tu equipo.`,
    }),
  },
  "Compras": {
    icon: ShoppingCart,
    accentColor: "from-violet-500 to-violet-600",
    accentBg: "bg-violet-500",
    accentText: "text-violet-300",
    badgeBg: "bg-violet-100 text-violet-700",
    ringColor: "ring-violet-300",
    getMessage: (name) => ({
      title: `Bienvenido, ${name}`,
      subtitle: "Gestion de Compras",
      body: `Tu gestion de compras al dia. Proveedores, cotizaciones y ordenes de compra organizadas en un solo lugar.`,
    }),
  },
  "Contador": {
    icon: Calculator,
    accentColor: "from-emerald-500 to-emerald-600",
    accentBg: "bg-emerald-500",
    accentText: "text-emerald-300",
    badgeBg: "bg-emerald-100 text-emerald-700",
    ringColor: "ring-emerald-300",
    getMessage: (name) => ({
      title: `Bienvenido, ${name}`,
      subtitle: "Contabilidad",
      body: `Los numeros te esperan. Revisa el flujo financiero, facturas y reportes contables de CEN Ingenieria.`,
    }),
  },
  "RRHH": {
    icon: Users,
    accentColor: "from-rose-500 to-rose-600",
    accentBg: "bg-rose-500",
    accentText: "text-rose-300",
    badgeBg: "bg-rose-100 text-rose-700",
    ringColor: "ring-rose-300",
    getMessage: (name) => ({
      title: `Bienvenido, ${name}`,
      subtitle: "Recursos Humanos",
      body: `Tu equipo humano es lo primero. Gestiona personal, asistencia y rendimiento desde aca.`,
    }),
  },
  "Operario Electricista": {
    icon: Wrench,
    accentColor: "from-orange-500 to-orange-600",
    accentBg: "bg-orange-500",
    accentText: "text-orange-300",
    badgeBg: "bg-orange-100 text-orange-700",
    ringColor: "ring-orange-300",
    getMessage: (name) => ({
      title: `Bienvenido, ${name}`,
      subtitle: "Operaciones",
      body: `Bienvenido al equipo. Revisa tus tareas asignadas y materiales disponibles para la jornada de hoy.`,
    }),
  },
};

const DEFAULT_CONFIG = {
  icon: Zap,
  accentColor: "from-[#2E6DA4] to-[#1A4A7A]",
  accentBg: "bg-[#2E6DA4]",
  accentText: "text-blue-300",
  badgeBg: "bg-blue-100 text-blue-700",
  ringColor: "ring-blue-300",
  getMessage: (name) => ({
    title: `Bienvenido, ${name}`,
    subtitle: "CEN Ingenieria",
    body: `Tu espacio de trabajo esta listo. Accede a tus modulos asignados y comenza tu jornada.`,
  }),
};

export default function WelcomeModal({ user, onClose }) {
  const [visible, setVisible] = useState(false);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(t);
  }, []);

  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  if (!user) return null;

  const firstName = user.name?.split(" ")[0] || "Usuario";
  const config = WELCOME_MESSAGES[user.role] || DEFAULT_CONFIG;
  const Icon = config.icon;
  const msg = config.getMessage(firstName);
  const initials = user.name
    ? user.name.split(" ").map((n) => n[0]).join("").toUpperCase().slice(0, 2)
    : "??";

  const now = new Date();
  const hour = now.getHours();
  const timeGreeting = hour < 12 ? "Buenos dias" : hour < 18 ? "Buenas tardes" : "Buenas noches";

  return (
    <div
      className={`fixed inset-0 z-[100] flex items-center justify-center p-4 transition-all duration-300 ${
        visible && !closing ? "opacity-100" : "opacity-0"
      }`}
      data-testid="welcome-modal-overlay"
    >
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-md"
        onClick={handleClose}
      />

      {/* Modal Card */}
      <div
        className={`relative w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-2xl transition-all duration-300 ${
          visible && !closing
            ? "scale-100 translate-y-0"
            : "scale-95 translate-y-4"
        }`}
        data-testid="welcome-modal"
      >
        {/* Gradient Header */}
        <div className={`relative bg-gradient-to-br ${config.accentColor} px-6 pt-8 pb-12 text-center overflow-hidden`}>
          {/* Decorative circles */}
          <div className="absolute -top-8 -right-8 w-32 h-32 rounded-full bg-white/10" />
          <div className="absolute -bottom-6 -left-6 w-24 h-24 rounded-full bg-white/10" />
          <div className="absolute top-4 left-8 w-3 h-3 rounded-full bg-white/20" />
          <div className="absolute top-12 right-12 w-2 h-2 rounded-full bg-white/30" />

          {/* Close button */}
          <button
            onClick={handleClose}
            className="absolute top-3 right-3 p-1.5 rounded-lg text-white/60 hover:text-white hover:bg-white/20 transition-all"
            data-testid="welcome-modal-close-btn"
          >
            <X size={18} />
          </button>

          {/* Avatar */}
          <div className="relative z-10 inline-flex items-center justify-center">
            <div className={`w-20 h-20 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center ring-4 ${config.ringColor}/30 shadow-lg`}>
              <span className="text-white text-2xl font-bold tracking-tight">{initials}</span>
            </div>
          </div>

          {/* Time greeting */}
          <p className={`relative z-10 mt-4 text-sm font-medium ${config.accentText} opacity-80`}>
            {timeGreeting}
          </p>

          {/* Name */}
          <h2 className="relative z-10 mt-1 text-2xl font-bold text-white tracking-tight" data-testid="welcome-modal-name">
            {msg.title}
          </h2>
        </div>

        {/* Content */}
        <div className="relative px-6 -mt-4">
          {/* Role badge card */}
          <div className="bg-white rounded-xl shadow-md border border-gray-100 p-4">
            <div className="flex items-center gap-3">
              <div className={`p-2.5 rounded-xl ${config.accentBg} shadow-sm`}>
                <Icon size={20} className="text-white" />
              </div>
              <div>
                <p className="text-xs font-semibold uppercase tracking-wider text-gray-400">Tu rol</p>
                <p className="text-sm font-bold text-gray-900">{user.role}</p>
              </div>
              <span className={`ml-auto text-xs font-semibold px-2.5 py-1 rounded-full ${config.badgeBg}`}>
                Activo
              </span>
            </div>
          </div>
        </div>

        {/* Message body */}
        <div className="px-6 pt-5 pb-6">
          <p className="text-sm text-gray-600 leading-relaxed" data-testid="welcome-modal-message">
            {msg.body}
          </p>

          {/* CTA Button */}
          <button
            onClick={handleClose}
            className={`mt-5 w-full bg-gradient-to-r ${config.accentColor} hover:opacity-90 active:scale-[0.98] text-white font-semibold py-3 rounded-xl transition-all duration-200 flex items-center justify-center gap-2 shadow-sm`}
            data-testid="welcome-modal-cta"
          >
            <Zap size={16} />
            Ir al Panel
          </button>

          <p className="mt-3 text-center text-[11px] text-gray-400">
            CEN Ingenieria E.A.S. &mdash; ERP v1.0
          </p>
        </div>
      </div>
    </div>
  );
}
